import { useTheme } from 'styled-components';

import { Flex } from 'common/flex';
import { Avatar } from 'common/avatar';

interface Props {
  name?: string;
  imageUri?: string;
  onImageClick?: () => void;
  placeholderIcon?: string;
}

export const NameContainer = ({
  name,
  imageUri,
  onImageClick,
  placeholderIcon,
}: Props) => {
  const theme = useTheme();

  return (
    <Flex
      overflow="hidden"
      flexDirection="row"
      alignItems="center"
      gap={theme.padding.small}
    >
      <Avatar
        src={imageUri}
        borderStyle="default"
        onClick={onImageClick}
        placeholderIcon={placeholderIcon}
      />
      <p className="elipsis">{name ?? '-/-'}</p>
    </Flex>
  );
};
